import { render, staticRenderFns } from "./AdminExtract.vue?vue&type=template&id=18d3b802&scoped=true"
import script from "./AdminExtract.vue?vue&type=script&lang=js"
export * from "./AdminExtract.vue?vue&type=script&lang=js"
import style0 from "./AdminExtract.vue?vue&type=style&index=0&id=18d3b802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3b802",
  null
  
)

export default component.exports